import type { FaireProductEntity } from "../../entity_types/product";

export const p_m5ckg86eb7: FaireProductEntity = {
  token: "p_m5ckg86eb7",
  type: "product",
  name: "A5 Single Notebook - Werner's Nomenclature of Colours",
  brandToken: "b_u89gdyfh23",
  brandName: "Roomytown Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/b721697f76f8f767bf65b467e2a4460e15542db6162336a9ff569c85cc4f9b91.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eb4d287b9acddc33219c34c20419edcc2f95668906be3366300866ae893052c6.jpeg",
  ],
  priceDollars: 5,
  description:
    "This 64 page lined notebook is the ideal companion for jotting down notes, thoughts, and ideas. The cover design captures the historial charm of Werner's Nomenclature of Colours, used by pioneers like Charles Darwin to categorise colours through nature's inspiration. Roomytown's design team in Bath, UK, have curated the design using an adaptation of colour swatches published by P. Syme in 1821. The notebook is finished with a coloured fabric spine for an added touch of sophistication. \n\nMM: 210mm H x 148mm W \nCM: H 21cm x W 14.8cm \nINCH: H 8.3\"\" x W 5.8\"\n\nExplore our wall prints and home decor, boasting charming designs for tea towels, trinket trays, playing cards, and notebooks. Embrace the upcoming seasons with delightful pieces perfect for gifting on occasions like Valentine's Day and Easter. Elevate your space with our unique home decor selections, capturing the essence of spring.\n\n Gifts For Her | Gifts for Him | Gifts for Kids",
  tags: [],
  msrpDollars: 11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:40:47.426Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
